import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { CardDashboardTradesPortfolioValue } from '../../../../../components/app/card/dashboard/trades/portfolio-value/card-dashboard-trades-portfolio-value';
import { CardDashboardTradesRealizedProfit } from '../../../../../components/app/card/dashboard/trades/realized-profit/card-dashboard-trades-realized-profit';
import { CardDashboardTradesUnrealizedProfit } from '../../../../../components/app/card/dashboard/trades/unrealized-profit/card-dashboard-trades-unrealized-profit';
import { CardDashboardTradesCurrencyImpact } from '../../../../../components/app/card/dashboard/trades/currency-impact/card-dashboard-trades-currency-impact';
import { CardDashboardTradesInvestedValue } from '../../../../../components/app/card/dashboard/trades/invested-value/card-dashboard-trades-invested-value';
import { CardDashboardTradesDividends } from '../../../../../components/app/card/dashboard/trades/dividends/card-dashboard-trades-dividends';
import { CardDashboardTradesAllTime } from '../../../../../components/app/card/dashboard/trades/all-time/card-dashboard-trades-all-time';
import { CardDashboardTradesFees } from '../../../../../components/app/card/dashboard/trades/fees/card-dashboard-trades-fees';
import { Slideshow } from '../../../../../components/app/swiper/swiper';
import { Responsive } from '../../../../../components/app/responsive/responsive';
import { Grid } from '../../../../../components/app/grid/grid';
import { SkeletonDashboardTradesCards } from '../../../../../components/app/skeleton/dashboard/trades/cards/skeleton-dashboard-trades-cards';

type DashboardTradesCardsType = {
    shared?: boolean;
};

export const DashboardTradesCards: React.FC<DashboardTradesCardsType> = observer(
    ({ shared = false }: DashboardTradesCardsType) => {
        const { statisticStore, portfolioStore } = useRootStore();
        const { overviewStore } = statisticStore;

        if (overviewStore.loading || portfolioStore.selectedPortfolio.isRecalculating) {
            return <SkeletonDashboardTradesCards />;
        }

        if (!overviewStore.overview) {
            return null;
        }

        return (
            <>
                <Responsive breakpoint={'md'} type={'min'}>
                    <Grid gap={1.6} cols={{ xs: 1, vl: 2 }}>
                        <Grid gap={1.6} cols={{ xs: 1 }}>
                            <Grid gap={1.6} cols={{ xs: 1, xl: 2 }}>
                                <CardDashboardTradesPortfolioValue />
                                <div className="flex h-full flex-col gap-small">
                                    <CardDashboardTradesRealizedProfit />
                                    <CardDashboardTradesUnrealizedProfit shared={shared} />
                                </div>
                            </Grid>
                            <CardDashboardTradesAllTime />
                        </Grid>
                        <Grid gap={1.6} cols={{ xs: 1 }}>
                            <CardDashboardTradesDividends shared={shared} />
                            <Grid gap={1.6} cols={{ xs: 1, xl: 2 }}>
                                <CardDashboardTradesInvestedValue shared={shared} />
                                <div className="flex h-full flex-col gap-small">
                                    <CardDashboardTradesCurrencyImpact />
                                    <CardDashboardTradesFees />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Responsive>
                <Responsive breakpoint={'md'} type={'max'}>
                    <Slideshow>
                        <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                            <CardDashboardTradesPortfolioValue />
                        </div>
                        <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                            <CardDashboardTradesInvestedValue shared={shared} />
                        </div>
                        <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                            <CardDashboardTradesAllTime />
                        </div>
                        <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                            <CardDashboardTradesDividends shared={shared} />
                        </div>
                        <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                            <CardDashboardTradesRealizedProfit />
                            <CardDashboardTradesUnrealizedProfit shared={shared} />
                        </div>
                        <div className="flex h-full min-h-full w-full flex-col items-stretch gap-vsmall">
                            <CardDashboardTradesCurrencyImpact />
                            <CardDashboardTradesFees />
                        </div>
                    </Slideshow>
                </Responsive>
            </>
        );
    },
);
